import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import EventBus from "../../util/EventBus";
import memoryContext from "../../util/MemoryContext";

export default function Logout() {

    const navigate = useNavigate();

    useEffect(() => {

        sessionStorage.clear();

       // @ts-ignore
        let memoryState = memoryContext[`Dashboard`];
        if (memoryState) {
            memoryState.developerEndpointEnterpriseObject = undefined;
            memoryState.developerEventEnterpriseObject = undefined;
            memoryState.developerApplicationEnterpriseObject = undefined;
        }

        // @ts-ignore
        EventBus.session.emit("update");

        navigate("/", {replace: true});

    }, [navigate]);

    return null;
}
